import { parseJSONSafe } from '@velasca/utils/parse-json-safe'

export const getLookbookPageData = () => {
  const pageGeneralOptionsEl = document.querySelector('#page-general-options')
  const pageGeneralOptionsJSON = pageGeneralOptionsEl?.innerHTML || '{}'

  const blocks = []
  let counter = 1

  while (true) {
    // Lookbook n
    const blockEl = document.querySelector<HTMLElement>(
      `#lookbook-product-${counter}`,
    )

    if (blockEl) {
      const blockJSON = blockEl?.innerHTML

      if (blockJSON) {
        const block = parseJSONSafe(blockJSON)

        if (block) {
          blocks.push(block)
        }
      }

      counter++
    } else {
      break
    }
  }

  return {
    pageGeneralOptions: parseJSONSafe(pageGeneralOptionsJSON),
    blocks,
  }
}
